import { Container, Row, Col } from "react-bootstrap";
import { useState, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import emailjs from '@emailjs/browser';
import heroImg from '../components/images/ranchWeddingImages/sunset.jpg';
import '../assets/css/contact.css';

export default function Contact() {
  const refForm = useRef();
  const [searchParams] = useSearchParams();
  const packageName = searchParams.get('package');
  const defaultMessage = packageName
    ? `Hello, I am interested in the ${packageName} package. Please contact me with more information!`
    : '';

  const [message, setMessage] = useState(defaultMessage);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const validate = () => {
    const form = refForm.current;
    const newErrors = {};
    if (!form['fullName'].value.trim()) newErrors.fullName = 'Please enter your name';
    if (!form['email'].value.trim()) newErrors.email = 'Please enter your email address';
    if (!form['Phone Number'].value.trim()) newErrors.phone = 'Please enter a contact number';
    if (!message.trim()) newErrors.message = 'Please tell us about your event';
    return newErrors;
  };

  const sendEmail = (e) => {
    e.preventDefault();
    const newErrors = validate();
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    emailjs.sendForm('service_mmvgfbk', 'template_qkubv6h', refForm.current, '2nzVernw8bscnVgID')
      .then(() => {
        setSubmitted(true);
        refForm.current.reset();
        setMessage('');
        setErrors({});
      }, () => {
        alert('Failed to send message, please try again.');
      });
  };

  return (
    <>
      <div className="contact-hero">
        <img src={heroImg} alt="Cascade Mountain Ranch" className="contact-hero-img" />
        <div className="contact-hero-overlay">
          <p className="contact-hero-eyebrow">Cascade Mountain Ranch</p>
          <h1>Let's Begin</h1>
          <p className="contact-hero-sub">Your perfect day starts with a conversation</p>
        </div>
      </div>

      <div className="contact-section">
        <Container>
          <Row className="contact-row">

            <Col lg={4} className="contact-info-col">
              <div className="contact-info">
                <h2>We'd Love To Hear From You</h2>
                <div className="contact-accent-line"></div>
                <p className="contact-intro">
                  Whether you're dreaming of an intimate elopement or a grand celebration,
                  our team is here to help bring your vision to life at Cascade Mountain Ranch.
                </p>
                <div className="contact-details">
                  <div className="contact-detail-item">
                    <span className="contact-label">Address</span>
                    <span>2500 Jumpoff Joe Creek Rd</span>
                    <span>Grants Pass, OR 97526</span>
                  </div>
                  <div className="contact-detail-item">
                    <span className="contact-label">Phone</span>
                    <a href="tel:5418908436">(541) 890-8436</a>
                  </div>
                  <div className="contact-detail-item">
                    <span className="contact-label">Email</span>
                    <a href="mailto:getaway@usa.com">getaway@usa.com</a>
                  </div>
                  <div className="contact-socials">
                    <a target="_blank" rel="noreferrer" href="https://www.facebook.com/CascadeMountainRanch/" aria-label="Facebook">
                      <FontAwesomeIcon icon={faFacebook} />
                    </a>
                    <a target="_blank" rel="noreferrer" href="https://www.instagram.com/cascade_mountain_ranch/" aria-label="Instagram">
                      <FontAwesomeIcon icon={faInstagram} />
                    </a>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg={8} className="contact-form-col">
              {submitted ? (
                <div className="contact-success">
                  <h3>Thank You</h3>
                  <div className="contact-accent-line"></div>
                  <p>We've received your message and will be in touch shortly. We look forward to making your vision a reality.</p>
                </div>
              ) : (
                <form ref={refForm} onSubmit={sendEmail} noValidate className="contact-form">
                  <Row>
                    <Col md={6}>
                      <div className="form-field">
                        <label htmlFor="fullName">Full Name <span className="required-star">*</span></label>
                        <input type="text" id="fullName" name="fullName" className={errors.fullName ? 'field-error-input' : ''} />
                        {errors.fullName && <span className="field-error-msg">{errors.fullName}</span>}
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="form-field">
                        <label htmlFor="email">Email Address <span className="required-star">*</span></label>
                        <input type="email" id="email" name="email" className={errors.email ? 'field-error-input' : ''} />
                        {errors.email && <span className="field-error-msg">{errors.email}</span>}
                      </div>
                    </Col>
                  </Row>
                  <div className="form-field">
                    <label htmlFor="phoneNumber">Phone Number <span className="required-star">*</span></label>
                    <input type="tel" id="phoneNumber" name="Phone Number" className={errors.phone ? 'field-error-input' : ''} />
                    {errors.phone && <span className="field-error-msg">{errors.phone}</span>}
                  </div>
                  <div className="form-field">
                    <label htmlFor="message">Tell Us About Your Event <span className="required-star">*</span></label>
                    <textarea
                      id="message"
                      name="message"
                      rows={6}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      className={errors.message ? 'field-error-input' : ''}
                    />
                    {errors.message && <span className="field-error-msg">{errors.message}</span>}
                  </div>
                  <button type="submit" className="contact-submit">Send Message</button>
                </form>
              )}
            </Col>

          </Row>
        </Container>
      </div>
    </>
  );
}
